import Semaphore from './Semaphore'

export default class Mutex {
  #semaphore = new Semaphore()

  async withLock(fn) {
    let error = null

    try {
      await this.#semaphore.acquire()
      await fn()
    } catch (e) {
      error = e
    }

    this.#semaphore.release()
    if (error) throw error
  }
}
